import React, { useState } from 'react';

import { IPhoto } from 'models/Photo';

import { API_BASE_URL } from '../../config';

interface IProps {
  photo: IPhoto;
  clickFunction: (x: IPhoto) => void;
}

const PhotoBox: React.FC<IProps> = ({ photo, clickFunction }: IProps) => {
  const thumbnailSrc = `${API_BASE_URL}/image/${photo.fileName}/thumbnail/`;
  const imageSrc = `${API_BASE_URL}/image/${photo.fileName}`;

  const [smallLoaded, setSmallLoaded] = useState(false);
  const [largeLoaded, setLargeLoaded] = useState(false);

  return (
    <div key={photo.fileName} className="image-placeholder">
      <div className={'relative'} id={photo.fileName}>
        <img
          src={thumbnailSrc}
          className={`image-small ${smallLoaded ? 'loaded' : ''}`}
          onLoad={() => setSmallLoaded(true)}
        />
        <div style={{ paddingBottom: '50%' }}></div>
        {smallLoaded && (
          <img
            src={imageSrc}
            className={largeLoaded ? 'loaded image w-full' : ''}
            onLoad={() => setLargeLoaded(true)}
          />
        )}
        <div
          onClick={() => clickFunction(photo)}
          className={'card-img-overlay w-full h-full cursor-pointer absolute top-0 p-3'}
        >
          {smallLoaded && (
            <span className={'cardTitle bg-slate-500 rounded-full px-3 py-1 text-white'}>
              {photo.title}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default PhotoBox;
